import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { ClinicAuthProvider } from "@/context/ClinicAuthContext";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import ProductPage from "@/pages/ProductPage";
import FinderPage from "@/pages/FinderPage";
import HowItWorksPage from "@/pages/HowItWorksPage";
import FaqPage from "@/pages/FaqPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PaymentCancelPage from "@/pages/PaymentCancelPage";
import RefillsPage from "@/pages/RefillsPage";
import RefillDetailPage from "@/pages/RefillDetailPage";
import LookbookPage from "@/pages/LookbookPage";
import ClinicsLandingPage from "@/pages/ClinicsLandingPage";
import ClinicLoginPage from "@/pages/ClinicLoginPage";
import ClinicDashboardPage from "@/pages/ClinicDashboardPage";
import ClinicNewOrderPage from "@/pages/ClinicNewOrderPage";
import OrderTrackPage from "@/pages/OrderTrackPage";
import SubscriptionsPage from "@/pages/SubscriptionsPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminOrdersPage from "@/pages/AdminOrdersPage";
import AdminCampaignsPage from "@/pages/AdminCampaignsPage";
import LandingPage from "@/pages/LandingPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ClinicAuthProvider>
          <AdminAuthProvider>
          <CartProvider>
            <Navbar />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/shop" element={<ShopPage />} />
              <Route path="/products/:id" element={<ProductPage />} />
              <Route path="/refills" element={<RefillsPage />} />
              <Route path="/refills/:id" element={<RefillDetailPage />} />
              <Route path="/lookbook" element={<LookbookPage />} />
              <Route path="/finder" element={<FinderPage />} />
              <Route path="/how-it-works" element={<HowItWorksPage />} />
              <Route path="/faq" element={<FaqPage />} />
              <Route path="/payment/success" element={<PaymentSuccessPage />} />
              <Route path="/payment/cancel" element={<PaymentCancelPage />} />
              <Route path="/clinics" element={<ClinicsLandingPage />} />
              <Route path="/clinics/login" element={<ClinicLoginPage mode="login" />} />
              <Route path="/clinics/register" element={<ClinicLoginPage mode="register" />} />
              <Route path="/clinics/dashboard" element={<ClinicDashboardPage />} />
              <Route path="/clinics/new-order" element={<ClinicNewOrderPage />} />
              <Route path="/order-track/:ref" element={<OrderTrackPage />} />
              <Route path="/account/subscriptions" element={<SubscriptionsPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin/orders" element={<AdminOrdersPage />} />
              <Route path="/admin/campaigns" element={<AdminCampaignsPage />} />
              <Route path="/go/:procedure" element={<LandingPage />} />
            </Routes>
            <Footer />
            <CartDrawer />
            <Toaster position="top-center" richColors />
          </CartProvider>
          </AdminAuthProvider>
        </ClinicAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
